import React from "react";
import styles from "../assets/lifeEnhancingChances.module.css";

const LifeEnhancingChances = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Empowering Communities Through Compassionate Care
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we believe in the power of community and the
              importance of supporting those in need. Our life-enhancing chances
              solutions are designed to make a positive impact on the lives of
              disadvantaged members of society by providing essential
              maintenance works at no fee. As part of our Corporate Social
              Responsibility (CSR) initiative, we are committed to giving back
              to the local community and promoting a more inclusive and caring
              society.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Compassionate Care</h4>
                <p className={styles.featureDescription}>
                  We prioritize the well-being of vulnerable individuals and
                  communities, offering our services with empathy, respect, and
                  compassion.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Meaningful Impact</h4>
                <p className={styles.featureDescription}>
                  Our life-enhancing chances solutions have a tangible and
                  meaningful impact on the lives of those we serve, improving
                  living conditions and fostering a sense of dignity and
                  belonging.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>
                  Collaborative Partnerships
                </h4>
                <p className={styles.featureDescription}>
                  We work closely with public sector housing providers and
                  community organisations to identify and address the needs of
                  disadvantaged individuals and families.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Empowerment</h4>
                <p className={styles.featureDescription}>
                  By providing essential maintenance works at no fee, we empower
                  individuals to live independently and thrive in their homes,
                  despite their challenges.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Maintenance Works</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Painting and Decorating
                  </h4>
                  <p className={styles.serviceDescription}>
                    We enhance the living spaces of disadvantaged individuals by
                    painting and decorating their homes, creating a more vibrant
                    and welcoming environment.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Vegetation Management</h4>
                  <p className={styles.serviceDescription}>
                    We cut back vegetation and maintain outdoor spaces for
                    disabled individuals who are unable to do so themselves,
                    improving accessibility and safety.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Minor Repairs</h4>
                  <p className={styles.serviceDescription}>
                    We address minor repairs and maintenance tasks to ensure
                    that homes are safe, functional, and comfortable for their
                    occupants.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Community Engagement</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Collaborative Approach
                  </h4>
                  <p className={styles.serviceDescription}>
                    We collaborate with local housing providers, community
                    organisations, and volunteers to identify individuals in
                    need of our services and coordinate support efforts.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Community Events</h4>
                  <p className={styles.serviceDescription}>
                    We organise community events and initiatives to raise
                    awareness of the challenges faced by disadvantaged
                    individuals and promote solidarity and mutual support within
                    the community.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Vegetation Management</h4>
                  <p className={styles.serviceDescription}>
                    We address overgrown vegetation and landscaping issues to
                    enhance the curb appeal and safety of the property.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Partner with Us</h4>
            <p className={styles.contactDescription}>
              Join us in making a difference in the lives of disadvantaged
              individuals and communities. Contact us today to learn more about
              our life-enhancing chances solutions and discover how you can
              contribute to our efforts to create a more caring and inclusive
              society.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifeEnhancingChances;
